export { default as NTimePicker, timePickerProps } from './src/TimePicker';
